var map = {
	"./de.svg": 71363,
	"./en.svg": 86559,
	"./fr.svg": 89730,
	"./ka.svg": 52014,
	"./kr.svg": 6749,
	"./right-arrow.svg": 92344,
	"./ru.svg": 91833,
	"./tr.svg": 38716,
	"./uz.svg": 19283,
	"./zh.svg": 39396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22256;